import {Component, Input, OnInit} from '@angular/core';
import {ShopDataService} from '@webu/data';
import {CtaType, pageTypes} from '@ox/typings';
import {buildTrackingString} from '@ox/utils';

@Component({
  selector: 'webu-cancel-plan-info',
  templateUrl: './cancel-plan-info.component.html'
})
export class CancelPlanInfoComponent implements OnInit {
  @Input() make: string;
  @Input() includeCancelFAQLink: boolean;
  
  public wantToCancel: string;

  trackingString = (cta: CtaType, args: string[]) => buildTrackingString(pageTypes.myPlans, cta, args);
  
  constructor(private shopDataService: ShopDataService) {}

  ngOnInit() {
    this.wantToCancel = this.shopDataService.getGenericCopy('myplans.cancel') ?? '';
  } 
}
